import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import sound from "../Food/Foodimage/alaram.mp3";

const CashBillingdata = () => {
  const [isHovered, setIsHovered] = useState(false);
  const [expandedOrder, setExpandedOrder] = useState(null);
  const [orders, setOrders] = useState([]);
  const [checkedItems, setCheckedItems] = useState({});
  const scrollContainerRef = useRef(null);

  // Default notification sound (a short "ding")
  const notificationSound = new Audio(sound);
  useEffect(() => {
    const storedVendorId = localStorage.getItem("vendorId");
    setVendorId(storedVendorId);
  }, []);
  const [vendorId, setVendorId] = useState(null);

  useEffect(() => {
    if (!vendorId) return;

    let previousOrderIds = [];

    const fetchOrders = async () => {
      try {
        const token = localStorage.getItem("authToken"); // ✅ Get token
        if (!token) {
          console.error("Authorization token is missing");
          return;
        }

        const response = await axios.get(
          `https://backend.maamaas.com/food/api/orders/vendor/${vendorId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`, // ✅ Include token in headers
            },
          }
        );

        const pendingCashOrders = response.data.filter(
          (order) =>
            order.cashStatus === "PENDING" && order.paymentMethod === "Cash"
        );

        const newOrderIds = pendingCashOrders.map((o) => o.orderId);
        const isNewOrder = newOrderIds.some((id) => !previousOrderIds.includes(id));

        // if (isNewOrder) {
        //   notificationSound.play().catch((e) =>
        //     console.warn("Autoplay prevented:", e)
        //   );
        // }

        previousOrderIds = newOrderIds;
        setOrders(pendingCashOrders);
      } catch (error) {
        // console.error("Error fetching orders:", error);
      }
    };

    fetchOrders();
    const intervalId = setInterval(fetchOrders, 1000);

    return () => clearInterval(intervalId);
  }, [vendorId]);


  // Auto-scroll logic
  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (!scrollContainer) return;

    let interval;

    const startScrolling = () => {
      interval = setInterval(() => {
        if (!isHovered) {
          scrollContainer.scrollTop += 1;

          if (scrollContainer.scrollTop >= scrollContainer.scrollHeight / 2) {
            scrollContainer.scrollTop = 0;
          }
        }
      }, 20);
    };

    startScrolling();

    return () => clearInterval(interval);
  }, [isHovered]);

  const getOrderColor = (orderType) => {
    const normalized = (orderType || "").trim().toLowerCase();
    switch (normalized) {
      case "dine_in":
        return "#1E90FF";
      case "takeaway":
        return "#FF6347";
      case "delivery":
        return "#20B2AA";
      case "table_dine_in":
        return "#1E90FF";
      default:
        return "#ccc";
    }
  };

  const handleOrderClick = (order) => {
    if (expandedOrder && expandedOrder.orderId === order.orderId) {
      setExpandedOrder(null);
    } else {
      setExpandedOrder(order);
    }
  };

  const handleCheckboxChange = (orderId, itemIndex) => {
    const key = `${orderId}-${itemIndex}`;
    setCheckedItems((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const handleAcceptOrder = async (e, orderId) => {
    e.stopPropagation();
    try {
      // ✅ Static values
      const status = "PENDING";       // enum path variable
      const cashStatus = "ACCEPT";    // query param

      // ✅ Get token from localStorage
      const authToken = localStorage.getItem("authToken");

      if (!authToken) {
        console.error("❌ No auth token found in localStorage");
        return;
      }

      // ✅ Build URL correctly
      const url = `https://backend.maamaas.com/food/api/orders/edit-orders/${orderId}/${status}?cashStatus=${cashStatus}`;

      // ✅ Call API with token
      const response = await axios.put(url, null, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${authToken}`, // ✅ include token
        },
      });

      // console.log(`✅ Order updated:`, response.data);
      window.location.reload();
      // ✅ Remove updated order from state
      setOrders((prev) => prev.filter((order) => order.orderId !== orderId));
    } catch (error) {
      console.error(`❌ Failed to update order:`, error.response?.data || error.message);
    }
  };







  const handleDeclineOrder = async (e, orderId) => {
    e.stopPropagation();
    try {
      // ✅ Static values
      const status = "PENDING";       // enum path variable
      const cashStatus = "DECLINE";    // query param

      // ✅ Get token from localStorage
      const authToken = localStorage.getItem("authToken");

      if (!authToken) {
        console.error("❌ No auth token found in localStorage");
        return;
      }

      // ✅ Build URL correctly
      const url = `https://backend.maamaas.com/food/api/orders/edit-orders/${orderId}/${status}?cashStatus=${cashStatus}`;

      // ✅ Call API with token
      const response = await axios.put(url, null, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${authToken}`, // ✅ include token
        },
      });

      // console.log(`✅ Order updated:`, response.data);

      // ✅ Remove updated order from state
      setOrders((prev) => prev.filter((order) => order.orderId !== orderId));
    } catch (error) {
      console.error(`❌ Failed to update order:`, error.response?.data || error.message);
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        top: "110px",
        bottom: "20px",
        right:window.innerWidth<=1100 ? " 5px"  : "16px",
        // width: "300px",
        borderRadius: "8px",
        padding: "10px",

        display: 'flex',
        flexDirection: 'column',
        display:window.innerWidth<768 ? "none" : "block",
      }}
      className="mobilescroll"
    >
      <div
        style={{
          flexGrow: 1,
          overflowY: "auto",
          paddingRight: "5px",
          scrollbarWidth: "thin",
          msOverflowStyle: "none",
        }}
        className="hide-scrollbar"

        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {orders.map((order, index) => (
          <div
            key={`${order.orderId}-${index}`}
            onClick={() => handleOrderClick(order)}
            className="card scroll-data-responsive"
            style={{
              cursor: "pointer",
              width:window.innerWidth<=1200 ? "98%" :"280px",
              marginBottom: "10px",
              background: getOrderColor(order.orderType),
              borderRadius: "8px",
              boxShadow: "0px 2px 4px rgba(0,0,0,0.1)",
              padding: "10px",
              position: "relative",
              transition: "all 0.3s ease",
              height:
                expandedOrder && expandedOrder.orderId === order.orderId
                  ? "auto"
                  : "120px",
            }}
          >
            <div style={{ width: "100%" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  color: "#fff",
                  fontWeight: "bold",
                }}
              >

                <div style={{display:"flex"}}>
                  <div
                    style={{

                      color: "rgba(255, 255, 255, 0.9)",
                      marginRight:"10px",
                      fontSize: "18px",
                      transition: "transform 0.3s ease",
                      transform: expandedOrder?.orderId === order.orderId ? "rotate(180deg)" : "rotate(0deg)",
                      // Add this line:
                      animation: expandedOrder?.orderId === order.orderId ? "none" : "pulse 1.5s infinite"
                    }}
                  >
                    ▼
                  </div>
                  Order ID: #{order.orderId}</div>
                <h5 style={{ marginTop: "-15px" }}>
                  {order.orderType || "N/A"}
                </h5>
                {/* Inside your .order-card div, add this after the order ID div */}

              </div>

              {expandedOrder && expandedOrder.orderId === order.orderId && (
                <div style={{ marginTop: "-10px" }}>
                  <h6 style={{ color: "#fff", fontSize: "20px" }}>Items:</h6>
                  <ul
                    style={{
                      listStyle: "none",
                      padding: 0,
                      marginLeft: "60px",
                      fontWeight: "bold",
                    }}
                  >
                    {(order.items || order.order || []).map((item, idx) => (
                      <li
                        key={idx}
                        style={{
                          color: "#000",
                          fontSize: "20px",
                          marginBottom: "2px",
                        }}
                      >
                        <label
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <input
                            type="checkbox"
                            checked={!!checkedItems[`${order.orderId}-${idx}`]}
                            onClick={(e) => e.stopPropagation()}
                            onChange={() =>
                              handleCheckboxChange(order.orderId, idx)
                            }
                          />
                          {item.dishName} × {item.quantity}
                        </label>
                      </li>
                    ))}
                  </ul>
                </div>
              )}

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "10px",
                }}
              >
                <button
                  onClick={(e) => handleAcceptOrder(e, order.orderId)}
                  style={{
                    padding: "8px",
                    backgroundColor: "rgb(177 93 198)",
                    color: "white",
                    fontSize: "14px",
                    fontWeight: "bold",
                    border: "none",
                    borderRadius: "5px",
                    cursor: "pointer",
                  }}
                >
                  Accept
                </button>
                <button
                  onClick={(e) => handleDeclineOrder(e, order.orderId)}
                  style={{
                    padding: "8px",
                    backgroundColor: "rgb(177 93 198)",
                    color: "white",
                    fontSize: "14px",
                    fontWeight: "bold",
                    border: "none",
                    borderRadius: "5px",
                    cursor: "pointer",
                  }}
                >
                  Decline
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
      <style>
        {`
        @keyframes pulse {
          0%, 100% { opacity: 0.7; }
          50% { opacity: 1; }
        }
      `}
      </style>
    </div>
  );
};

export default CashBillingdata;
